<template>
  <el-select
    :style="{ width: width }"
    size="small"
    v-model="roleId"
    :loading="isLoading"
    filterable
    clearable
    remote
    :remote-method="getList"
    placeholder="请选择"
  >
    <el-option
      v-for="item in list"
      :label="item.userName"
      :value="item.id"
      :key="item.id"
    />
  </el-select>
</template>

<script>
import { getUserListAPI } from "./api.js";

export default {
  name: "SelectAdmin",

  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    width: {
      type: String,
      default: "400px"
    }
  },

  computed: {
    roleId: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },

  data() {
    return {
      list: [],
      isLoading: false,
    }
  },

  created() {
    this.getList("");
  },

  methods: {
    async getList(query) {
      let params = {
        page: 1,
        pageSize: 20,
        userName: query
      };
      this.list = await getUserListAPI(params);
    }
  }
}
</script>
